/* eslint-disable prettier/prettier */
import React, { useCallback } from 'react';
import PoolsTitleBarLayout from './PoolsTitleBarLayout';
import PlayerGroupSection from './PlayerGroupSection';
import StatusOrRoundsSection from './StatusOrRoundsSection';
import ViewPoolButton from './ViewPoolButton';

const PoolsTitleBar = ({ playerGroupName, pool, poolAction, setSelectedPool, isAdmin }) => {
    const handlePoolPress = useCallback(() => {
        poolAction();
        setSelectedPool(pool?.id);
    }, [poolAction, setSelectedPool, pool]);

    return (
        <PoolsTitleBarLayout>
            <PlayerGroupSection playerGroupName={playerGroupName} pool={pool} isAdmin={isAdmin} />
            <StatusOrRoundsSection pool={pool} isAdmin={isAdmin} />
            <ViewPoolButton onClick={handlePoolPress} />
        </PoolsTitleBarLayout>
    );
};

export default PoolsTitleBar;
